import {
  MESSAGES_SHOW
} from './types';

export function showMessage(msg) {
  return dispatch => {
    dispatch({
            type: MESSAGES_SHOW,
            payload: msg
          })
    setTimeout(() => {
          dispatch({
            type: MESSAGES_SHOW,
            payload: ""
          })
    }, 5000);
  }
}



// WEBPACK FOOTER //
// ./src/data/messages/actions.js